import React, { useState } from "react"
import Container from "react-bootstrap/Container"
import Nav from "react-bootstrap/Nav"
import Navbar from "react-bootstrap/Navbar"
import { useNavigate, useLocation, NavLink } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { logout } from "../../data/authenticationSlice"

const componentStyle = {
    background: "#fff !important",
    height: "80px !important",
    position: "fixed",
    top: "0",
    left: "0",
    width: "100%",
    boxShadow: "0 0 8px 0 rgba(0, 0, 0, 0.4)",
    zIndex: "5",
    paddingTop: "12px",
    marginBottom: "50px"
}

function AdminNavBar() {
    const navigate = useNavigate()
    const location = useLocation()
    const dispatch = useDispatch()
    const [expanded, setExpanded] = useState(false)

    const { role } = useSelector((state) => state.authentication)

    const handleToggle = () => setExpanded(!expanded)

    const _logout = (e) => {
        e.preventDefault()
        const refreshToken = window.sessionStorage.getItem("REFRESH_TOKEN")
        dispatch(logout({ refreshToken })).then(() => {
            let loc = location.pathname.split("/")[1]

            if (loc) {
                let route = loc === "admin" ? "/admin/login" : "/agency/login"
                navigate(route)
            }
        })
    }

    const handleNavLinkClick = () => {
        if (expanded) setExpanded(false)
    }

    return (
        <Navbar
            style={componentStyle}
            expand="lg"
            className="bg-body-tertiary"
            expanded={expanded}>
            <Container fluid>
                <NavLink
                    to="/admin/"
                    className="me-5">
                    <img
                        src="/GAIC.png"
                        alt="Mountain"
                        className="logo"
                    />
                </NavLink>
                <Navbar.Toggle
                    aria-controls="basic-navbar-nav"
                    onClick={handleToggle}
                />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <NavLink
                            className="nav-link"
                            to="/admin/applications"
                            onClick={handleNavLinkClick}>
                            Applications
                        </NavLink>

                        <NavLink
                            className="nav-link"
                            to="/admin/agencies-and-contracts"
                            onClick={handleNavLinkClick}>
                            Agencies and Contacts
                        </NavLink>

                        <NavLink
                            className="nav-link"
                            to="/admin/gai-users"
                            onClick={handleNavLinkClick}>
                            GAI Users
                        </NavLink>

                        <NavLink
                            className="nav-link"
                            to="/admin/reporting"
                            onClick={handleNavLinkClick}>
                            Reporting
                        </NavLink>
                        {role !== "Standard" && (
                            <NavLink
                                className="nav-link"
                                to="/admin/endorsements"
                                onClick={handleNavLinkClick}>
                                Endorsements
                            </NavLink>
                        )}

                        <NavLink
                            className="nav-link"
                            to="/admin/profile"
                            onClick={handleNavLinkClick}>
                            Profile
                        </NavLink>
                        <NavLink>
                            <p
                                className="nav-link p-cleaned"
                                onClick={(e) => {
                                    handleNavLinkClick()
                                    _logout(e)
                                }}>
                                Logout
                            </p>
                        </NavLink>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    )
}

export default AdminNavBar
